export default "__VITE_ASSET__C9$wzP7h__"